import { render, staticRenderFns } from "./EducationalPeriodUpdate.vue?vue&type=template&id=31b48ec0&"
import script from "./EducationalPeriodUpdate.vue?vue&type=script&lang=js&"
export * from "./EducationalPeriodUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports